import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CareerSiteLanguageType } from '@locale/locale-store';

import { unhandledRequest } from './request';

export type Translation = {
  title: string;
  language: CareerSiteLanguageType;
};

export type Message = {
  id: number;
  applicationId: number;
  applicationName: string;
  applicationEmail: string;
  applicationPicture: string;
  applicationNumMessages: number;
  applicationAssignedToId: number | null;
  applicationStatus: 'hired' | 'rejected' | 'retracted' | 'active';
  jobId: number;
  jobStageName: string;
  jobLanguages: Translation[];
  jobTitle?: string;
  message: string;
  created: string;
  userId?: number;
  failed: boolean;
  unread: boolean;
  labels?: string;
};

export type MessageResponse = {
  count: number;
  next: string;
  previous: string;
  results: Message[];
};

export type SubmitError = AxiosError<{ error: string }>;

export async function list(queryString: string) {
  const response = await unhandledRequest.get<MessageResponse>({
    url: '/messages/' + queryString,
  });

  return response.data;
}

export async function loadCount() {
  const response = await unhandledRequest.get<number>({
    url: '/count/messages/',
  });

  return response.data;
}

export const useMessageCount = () => {
  return useQuery({
    queryKey: ['messages-count'],
    queryFn: loadCount,
  });
};

export const useMessageList = (queryString: string, options?: UseQueryOptions<MessageResponse>) => {
  return useQuery({
    queryKey: ['messages', 'list', queryString],
    queryFn: () => list(queryString),
    ...options,
  });
};
